import React from 'react';
import { motion } from 'framer-motion';
export function Sponsors() {
  return <section id="sponsor" className="py-20 lg:py-28 bg-white" data-id="element-159">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-160">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center" data-id="element-161">
          {/* Left: Content */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} data-id="element-162">
            <h2 className="text-4xl md:text-5xl font-display font-bold text-usa-navy mb-6" data-id="element-163">
              BECOME A CORPORATE SPONSOR
            </h2>
            <div className="w-16 h-1 bg-usa-red mb-8" data-id="element-164" />

            <p className="text-lg text-gray-700 mb-10" data-id="element-165">
              Local businesses, martial arts supporters, and community partners
              can help Cyrus continue to train and compete while being
              recognized on this site.
            </p>

            {/* Sponsor Logo Placeholders - 2x2 */}
            <div className="grid grid-cols-2 gap-4 mb-10 opacity-60 grayscale" data-id="element-166">
              {[1, 2, 3, 4].map(i => <div key={i} className="aspect-[3/2] bg-gray-100 flex items-center justify-center border border-gray-200" data-id="element-167">
                  <span className="font-display text-xs sm:text-sm text-gray-400 tracking-widest" data-id="element-168">
                    YOUR LOGO HERE
                  </span>
                </div>)}
            </div>

            <a href="mailto:contact@tkdfuture.com" className="inline-block bg-usa-navy hover:bg-gray-900 text-white font-display text-xl px-10 py-4 tracking-wider transition-colors" data-id="element-169">
              ASK ABOUT SPONSORING CYRUS
            </a>
          </motion.div>

          {/* Right: Video Short */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="flex flex-col items-center lg:items-start" data-id="element-170">
            <div className="text-center lg:text-left mb-4 w-full max-w-sm mx-auto" data-id="element-171">
              <span className="text-xs font-bold text-usa-red uppercase tracking-widest block mb-2" data-id="element-172">
                A Message From Cyrus
              </span>
              <h3 className="font-display text-2xl text-usa-navy" data-id="element-173">
                See Why It Matters
              </h3>
            </div>
            <div className="relative w-full max-w-sm mx-auto aspect-[9/16] bg-usa-navy shadow-2xl border-4 border-usa-navy overflow-hidden" data-id="element-174">
              <iframe src="https://www.youtube.com/embed/DkNC4i8hjBE" title="Sponsor Cyrus - A Message" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen className="absolute inset-0 w-full h-full" data-id="element-175" />
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}